// extracted by mini-css-extract-plugin
export default {"ligContainer":"style_ligContainer__aQU1m"};